export const invertedMessages = {
  'Don’t show me this message again for this certification':
    'CERTS_DONT_SHOW_ME_MSG',
  'This campaign has been configured so that the following items will be revoked after the due date:':
    'CERTS_REVOKE_DATE_DETAIL',
  'Automatic Access Revocation Notice': 'CERTS_REVOKE_TITLE',
  'If you don’t submit your certification by the due date ({revokeDueDate}), some access will be automatically revoked.':
    'CERTS_REVOKE_AUTO_MSG',
  'Show Less': 'CERTS_SHOW_LESS',
  'Show More': 'CERTS_SHOW_MORE',
};
